import { OrderRejectionReason } from '../../../../../../../services/exports/Constants';

export default {
  statuses: {
    rejected: 'Peruutettu: {{reason}}',
    fulfilled: 'Tämä tilaus on toimitettu onnistuneesti',
  },
  rejection_reasons: {
    [OrderRejectionReason.Automatic]: 'Ei hyväksytty',
    [OrderRejectionReason.ClosingSoon]: 'Suljetaan pian',
    [OrderRejectionReason.ItemUnavailable]: 'Tuote ei saatavilla',
    [OrderRejectionReason.OrderTooBig]: 'Tilaus liian suuri',
    [OrderRejectionReason.CustomerMistake]: 'Asiakkaan erehdys',
    [OrderRejectionReason.Other]: 'Muu',
    fully_refunded: 'Tilaus hyvitettiin kokonaan',
  },
};
